<template>
<div>
    <!-- modal -->
    <b-modal id="departmentUnitFormModal" centered size="xl" no-close-on-backdrop ref="departmentUnitFormModal" :title=" $t('department.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" @close="clear()">
        <validation-observer ref="simpleRules">
            <b-form>
                <label for="department-name-input">{{ $t('department.name') }}</label>
                <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('department.name')" rules="required">
                        <b-form-input size="sm" id="department-name-input" v-model="departmentName" maxlength="50" :state="errors.length > 0 ? false:null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-form>
        </validation-observer>
        <b-card :hidden="hiddenControl">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab :title="$t('department.sub_department')" active style="width:100%;">
                            <b-card-text>
                                <sub-department-list :getSubDepartmentList="getSubDepartmentList" :departmentId="this.id"></sub-department-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getSubDepartmentList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            departmentName: '',
            hiddenControl: true,
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['departmentUnitFormModal'].show()
            this.id = id
            if (this.id == 0) {
                this.hiddenControl = true
            } else {
                this.hiddenControl = false
            }
            const data = {
                id: this.id
            }
            const controller = {
                name: 'Department'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.departmentName = response.data.department.name
                } else {
                    this.$bvModal.hide('departmentUnitFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.departmentName
            }
            const controller = {
                name: 'Department'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('departmentUnitFormModal')
                            this.getDepartmentList()
                            this.$SaveAlert()
                            this.hiddenControl = false

                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        clear() {
            this.id = 0
            this.departmentName = ''
            this.hiddenControl = true
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
